import * as localforage from "localforage";
import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const getUsbPortListApi = async device_id => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/device/usb/ports`,
    method: "GET",
    params: {
      company_id,
      device_id
    }
  });
  return res.data;
};
export const detectUsbPortApi = async device_ids => {
  let res = await axios({
    url: `/api/v2/command/detect-usb-port-send`,
    method: "POST",
    data: {
      device_ids,
      execute_type: "detect_usb_ports"
    }
  });
  return res.data;
};

export const detectPrinterApi = async device_ids => {
  let res = await axios({
    url: `/api/v2/command/detect-usb-port-send`,
    method: "POST",
    data: {
      device_ids,
      execute_type: "device_printers"
    }
  });
  return res.data;
};

export const setUsbPortStatusApi = async (
  ids,
  port_id,
  status_value,
  t,
  successfulText,
  execute_type="set_usb_port"
) => {
  const device_ids = [ids];
  const status = status_value ? "Enable" : "Disable";

  let res = await axios({
    url: `/api/v2/command/set-usb-port-send`,
    method: "POST",
    data: {
      device_ids,
      port_id,
      status,
      execute_type
    }
  });
  successHandling(t, successfulText);
  return res.data;
};
